import { takeLatest, put, call } from 'redux-saga/effects';
import { toast } from 'react-toastify';

import { routePath } from 'app/services/helpers'
import axios from 'app/services/http/axios';

// -------

import {Actions} from './slice';
import { Api } from 'modules/Admin/Reports'

// -------

function* getReport({payload: {id}}) {
  try {
    const route = routePath(Api.report, { id })

    const response = yield call(axios.get, route);
    yield put(Actions.getReportSuccess(response));

  } catch (e) {
    return yield put(Actions.getReportFailed(e));
  }
}

function* getFormFilters() {
  try {
    const response = yield call(axios.get, Api.formFilters);

    // Response contains both formTypes and companies
    const { formTypes = [], companies = [] } = response || {};

    console.log('Form Filters Response:', response);
    console.log('Form Types:', formTypes);
    console.log('Companies:', companies);

    yield put(Actions.getFormFiltersSuccess({
      formTypes: Array.isArray(formTypes) ? formTypes : [],
      companies: Array.isArray(companies) ? companies : []
    }));

  } catch (e) {
    console.error('Get form filters error:', e);
    return yield put(Actions.getFormFiltersFailed(e));
  }
}

function* getFormType({payload: {id}}) {
  try {
    const route = `${Api.formTypes}/${id}`;
    const response = yield call(axios.get, route);
    yield put(Actions.getFormTypeSuccess(response));
  } catch (e) {
    return yield put(Actions.getFormTypeFailed(e));
  }
}

function* save({ payload: {id, values} }) {

  try {
    const route = routePath(Api.report, { id: id === 0 ? 'create' : id })

    const response = yield call(axios.post, route, values);

    yield put(Actions.saveFormSuccess(response));

  } catch (e) {
    console.error('Save error:', e);
    return yield put(Actions.saveFormFailed(e));
  }
}

export function* watchReportFormSaga() {
  yield takeLatest(Actions.getReport.type, getReport)
  yield takeLatest(Actions.getFormFilters.type, getFormFilters)
  yield takeLatest(Actions.getFormType.type, getFormType)
  yield takeLatest(Actions.saveForm.type, save)
}

export default watchReportFormSaga
